import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { NavLink, useLocation } from "react-router-dom";
import tiranaImg from "../../assets/tirana.jpg";

const Hero: React.FC = () => {
  const { t } = useTranslation("home");
  const location = useLocation();
  const language = location.pathname.split("/")[1];
  return (
    <Box
      sx={{
        position: "relative",
        height: "100vh",
        backgroundImage: `url(${tiranaImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          backgroundColor: "rgba(0, 0, 0, 0.75)",
        }}
      />
      <Box
        sx={{
          position: "relative",
          zIndex: 10,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          textAlign: "center",
          color: "white",
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: { xs: "1.5rem", md: "3rem", lg: "3.5rem" },
            fontWeight: "600",
            marginBottom: 2,
            maxWidth: "1050px",
            color: "#FFFFFF",
            textTransform: "uppercase",
          }}
        >
          {t("hero")}
        </Typography>
        <p className="text-lg max-w-4xl mb-8 px-4">{t("hero_description")}</p>
        <NavLink to={`/${language}/about`}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "main",
              ":hover": { backgroundColor: "darkred" },
              py: 1.5,
              px: 5,
              borderRadius: "5px",
              fontSize: "1.2rem",
              textTransform: "none",
              boxShadow: "none",
            }}
            onClick={() => {
              window.scrollTo({
                top: 0,
              });
            }}
          >
            {t("read_more")}
          </Button>
        </NavLink>
      </Box>
    </Box>
  );
};

export default Hero;
